<template>
    <v-dialog v-model="isOpen" width="30%">
        <template v-slot:activator="{ on }">
            <slot name="activator" v-bind="{ on }" />
        </template>

        <v-card>
            <v-toolbar dense flat>
                <v-toolbar-title class="title primary--text">
                    Suppression notaire
                </v-toolbar-title>

                <v-spacer />

                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn @click="isOpen = false" color="primary" icon v-on="on">
                            <v-icon> far fa-times-circle </v-icon>
                        </v-btn>
                    </template>
                    Fermer la fenêtre
                </v-tooltip>
            </v-toolbar>

            <v-divider />

            <v-card-text class="pt-4">
                Voulez-vous vraiment supprimer le notaire {{ notary.name }} ?
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn @click="submit()" color="error" small> Supprimer </v-btn>

                <v-spacer />

                <v-btn @click="isOpen = false" small> Annuler </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'BuyerNotaryDeletionDialog',

    props: {
        saleId: { type: Number, required: true },
        buyer: { type: Object, required: true },
        notary: { type: Object, required: true }
    },

    data: () => ({
        isOpen: false
    }),

    methods: {
        async submit() {
            try {
                this.setLoading(true);

                const body = {
                    buyers: [{
                        id: this.buyer.id,
                        type: this.buyer.type,
                        notary: {
                            id: this.notary.id,
                            remove: true
                        }
                    }]
                };

                const { success, err } = await this.repos.sales.updateSale(this.saleId, body);
                if (success) {
                    this.isOpen = false;
                    this.$emit('reload');
                } else {
                    if (err) {
                        console.error(err);
                        throw new Error();
                    } else {
                        // 
                    }
                }
            } catch (err) {
                console.error(err);
                this.$notify({
                    title: 'Erreur',
                    text: 'Une erreur est survenue lors de la suppression du notaire',
                    type: 'error'
                });
            } finally {
                this.setLoading(false);
            }
        }
    }
};
</script>
